import { render, staticRenderFns } from "./SalarioMinimo.vue?vue&type=template&id=4acd7bb6&scoped=true"
import script from "./SalarioMinimo.vue?vue&type=script&lang=js"
export * from "./SalarioMinimo.vue?vue&type=script&lang=js"
import style0 from "./SalarioMinimo.vue?vue&type=style&index=0&id=4acd7bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd7bb6",
  null
  
)

export default component.exports